export default __webpack_public_path__ + "static/media/credi_cards.bb48f389.png";